module.exports = __webpack_public_path__ + "static/media/blom-pysanky-89.3e47c488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-89.jpg
// module id = 3782
// module chunks = 14